export default function makeQueries(queries: string, param: string) {
  let newQueries = queries || '';
  if (newQueries) newQueries += `&${param}`;
  else newQueries += param;

  return newQueries;
}

export { makeQueries };
